import common from './whiteTheme/commonStyle.oci';
import landscape from './whiteTheme/landscape.oci';
import portrait from './whiteTheme/portrait.oci';

export let commonStyles = common;
export let landscapeStyle = landscape;
export let portraitStyles = portrait;
